import React from 'react'

import { BreadcrumbsItem } from './Item'

interface BreadcrumbsProps extends Omit<React.HTMLAttributes<HTMLElement>, 'className'> {
  children: React.ReactNode;
}

export function Breadcrumbs ({ children, ...props }: BreadcrumbsProps) {
  return (
    <nav aria-label='breadcrumbs' {...props}>
      <ol className='flex items-center group/breadcrumbs body-sm text-gray-800 font-normal'>
        {children}
      </ol>
    </nav>
  )
}

Breadcrumbs.Item = BreadcrumbsItem
